import { put, takeEvery } from 'redux-saga/effects';
import { LOGOUT } from './logout.action';
import {push} from "redux-first-history";
import {urlLocations} from "routes/urlLocations";
import instance from "services/root.api";

function* logout() {
    try {
        const storage = localStorage.getItem("storageTyp");
        window[storage]?.removeItem('jwt');

        delete instance.defaults.headers.common["Authorization"];
        // Instead of using history.push, dispatch a navigation action
        yield put(push(urlLocations.login));

    } catch (error) {
        console.log(error);
    }
}

export function* watchLogout() {
    yield takeEvery(LOGOUT, logout);
}
